var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "laundry_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "laundry_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L14,0.01 C15.11,0.01 16,0.89 16,2 L16,18 C16,19.11 15.11,20 14,20 L2,20 C0.89,20 0,19.11 0,18 L0,2 C0,0.89 0.89,0 2,0 Z M8,6 C4.69,6 2,8.69 2,12 C2,15.31 4.69,18 8,18 C11.31,18 14,15.31 14,12 C14,8.69 11.31,6 8,6 Z M10.83,9.17 C12.39,10.73 12.39,13.27 10.83,14.83 C9.27,16.39 6.73,16.39 5.17,14.83 Z M6,2 C5.45,2 5,2.45 5,3 C5,3.55 5.45,4 6,4 C6.55,4 7,3.55 7,3 C7,2.45 6.55,2 6,2 Z M3,2 C2.45,2 2,2.45 2,3 C2,3.55 2.45,4 3,4 C3.55,4 4,3.55 4,3 C4,2.45 3.55,2 3,2 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.0 -1264.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#laundry_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.0 1262.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.0 2.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#laundry_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16,0 16,20 0,20 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.bfeade744a31f57176e93c3fdb60ccfe.svg";
export { ForwardRef as ReactComponent };